<template>
  <div class="rpt-chain-operation">
    <div class="report-shell">
      <header class="report-header">
        <div class="header-row">
          <div>
            <h1>业务链群经营情况</h1>
            <p class="subtitle">
              按业务链群查看 H1 百万元级客户签约、丢单复盘和 H2
              商机储备，页签同步标识链群对应行业及负责人。
            </p>
          </div>
          <div class="header-actions">
            <span class="report-badge"
              ><i class="fa fa-clock-o"></i> 更新至 2026-07-24</span
            >
            <!-- <button type="button" class="analysis-button" @click="requestAnalysis">
              <i class="fa fa-magic"></i><span>智能分析</span>
            </button> -->
          </div>
        </div>
      </header>

      <nav class="tab-strip">
        <button
          v-for="chain in chains"
          :key="chain.key"
          type="button"
          class="chain-tab"
          :class="{ 'is-active': chain.key === activeKey, 'is-disabled': chain.disabled }"
          @click="!chain.disabled && (activeKey = chain.key)"
          :disabled="chain.disabled"
        >
          <span class="chain-tab-name">{{ chain.name }}</span>
          <span class="chain-tab-industry">{{ chain.industry }}</span>
        </button>
      </nav>

      <section class="content-card" v-if="activeChain">
        <div id="chain-report">
          <div class="chain-summary">
            <div class="chain-identity">
              <span class="chain-icon"><i class="fa fa-sitemap"></i></span>
              <div>
                <div class="chain-name">{{ activeChain.name }}</div>
                <div class="chain-meta">
                  负责人：{{ activeChain.owner }} · 行业归属：{{ activeChain.industry }} ·
                  客户经营口径：百万元级
                </div>
              </div>
            </div>
            <div class="chain-summary-kpis">
              <div class="chain-summary-kpi">
                <span>H1 签约额</span
                ><strong class="tone-primary">{{ num(chainSigned) }} 万</strong>
              </div>
              <div class="chain-summary-kpi">
                <span>H1 丢单额</span
                ><strong class="tone-negative">{{ num(chainLost) }} 万</strong>
              </div>
            </div>
          </div>

          <div class="business-panels">
            <article class="business-panel">
              <div class="business-panel-head">
                <div class="business-panel-title">
                  <i class="fa fa-handshake-o"></i><span>H1 百万级客户签约情况</span>
                </div>
                <div class="business-panel-conclusion">
                  已签约 {{ signedCount }} 家 · 合计 {{ num(signedSum) }} 万元
                </div>
              </div>
              <div class="mini-table-scroll">
                <table class="mini-table">
                  <thead>
                    <tr>
                      <th>已签约客户</th>
                      <th>签约额</th>
                      <th>服务内容</th>
                      <!-- <th>毛利率</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="total-row">
                      <td>合计</td>
                      <td class="numeric">{{ num(signedSum) }}</td>
                      <td>—</td>
                      <!-- <td class="numeric">{{ chainMargin.toFixed(1) }}%</td> -->
                    </tr>
                    <tr v-for="(row, i) in signedRows" :key="'s' + i">
                      <td>{{ row[0] }}</td>
                      <td class="numeric">{{ num(row[1]) }}</td>
                      <td class="text-left">{{ row[2] }}</td>
                      <!-- <td class="numeric">{{ row[3].toFixed(1) }}%</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>

            <article class="business-panel">
              <div class="business-panel-head">
                <div class="business-panel-title">
                  <i class="fa fa-exclamation-triangle"></i
                  ><span>H1 百万级客户丢单情况</span>
                </div>
                <div class="business-panel-conclusion">
                  丢单 {{ lostCount }} 家 · 合计 {{ num(lostSum) }} 万元
                </div>
              </div>
              <div class="mini-table-scroll">
                <table class="mini-table">
                  <thead>
                    <tr>
                      <th>丢单客户</th>
                      <th>丢单额</th>
                      <th>丢单原因</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="total-row">
                      <td>合计</td>
                      <td class="numeric">{{ num(lostSum) }}</td>
                      <td>—</td>
                    </tr>
                    <tr v-for="(row, i) in lostRows" :key="'l' + i">
                      <td>{{ row[0] }}</td>
                      <td class="numeric">{{ num(row[1]) }}</td>
                      <td class="text-left">{{ row[2] }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
          </div>
        </div>
        <footer class="report-foot">
          <span
            >金额单位：万元；百万级客户指单一客户 H1 已签约、H1 丢单或 H2 有效商机金额达到
            100 万元。</span
          >
          <span
            >数据来源：CRM、商机漏斗、投标复盘和链群经营台账；示例数据用于经营分析展示。</span
          >
        </footer>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const CHAINS = [
  { key: 'smart-manufacturing', name: '智能制造', industry: '家电 / 汽车 / 机械装备', owner: '待定', disabled: false },
  { key: 'smart-line', name: '智能产线', industry: '机械装备行业', owner: '丁斌', disabled: true },
  { key: 'machine-vision', name: '机器视觉', industry: '泛半导体行业', owner: '王暾', disabled: true },
  { key: 'chemical', name: '化工行业', industry: '流程行业', owner: '张乐交', disabled: false },
  { key: 'industrial-platform', name: '工赋平台', industry: '家电行业', owner: '刁兴全', disabled: true },
  { key: 'smart-energy', name: '智慧能源', industry: '流程行业', owner: '邵凯', disabled: true },
  { key: 'carbon-energy', name: '碳索能源', industry: '泛半导体行业', owner: '张智权', disabled: false },
  { key: 'aiot', name: 'AIOT解决方案', industry: '家电行业', owner: '侯正领', disabled: true }
]

export default {
  name: 'ChainOperationReport',
  data() {
    return {
      chains: CHAINS,
      activeKey: CHAINS[0].key,
      loading: false,
      chainSummary: null,
      signedRows: [],
      lostRows: [],
      signedTotal: 0,
      lostTotal: 0,
      signedSum: 0,
      lostSum: 0
    }
  },
  async created() {
    await this.fetchChainData()
  },
  watch: {
    activeKey() {
      this.fetchChainData()
    }
  },
  computed: {
    activeChain() {
      var chain = this.chains.find((c) => c.key === this.activeKey) || this.chains[0]
      return {
        key: chain.key,
        name: chain.name,
        industry: (this.chainSummary && this.chainSummary.industry) || chain.industry,
        owner: (this.chainSummary && this.chainSummary.leader) || chain.owner,
        disabled: chain.disabled
      }
    },
    chainSigned() {
      return this.chainSummary ? Number(this.chainSummary.sign_amount || 0) : 0
    },
    chainLost() {
      return this.chainSummary ? Number(this.chainSummary.lost_amount || 0) : 0
    },
    signedCount() {
      return this.signedTotal
    },
    lostCount() {
      return this.lostTotal
    }
  },
  methods: {
    num(v) {
      return Math.round(v).toLocaleString('zh-CN')
    },
    async fetchChainData() {
      var chainName = this.chains.find((c) => c.key === this.activeKey).name
      var sign100Param = chainName === '智能制造' ? '智能制造新,汽车汽配,咨询链群' : chainName
      this.loading = true
      try {
        var results = await Promise.all([
          axios.post(
            'https://bigdata.cosmoplat.com/prod-api/system/api/call/cosmoplat/chain-group/sign-lost-amount',
            { secret: '88py6X', paramList: [{ paramName: 'chain_group', paramValue: chainName }] },
            { headers: { 'Content-Type': 'application/json' }}
          ),
          axios.post(
            'https://bigdata.cosmoplat.com/prod-api/system/api/call/cosmoplat/chain-group/sign100',
            { secret: '88py6X', paramList: [{ paramName: 'chain_group', paramValue: sign100Param }] },
            { headers: { 'Content-Type': 'application/json' }}
          ),
          axios.post(
            'https://bigdata.cosmoplat.com/prod-api/system/api/call/cosmoplat/chain-group/lost100',
            { secret: '88py6X', paramList: [{ paramName: 'chain_group', paramValue: chainName }] },
            { headers: { 'Content-Type': 'application/json' }}
          )
        ])
        this.chainSummary = (results[0].data && results[0].data.data && results[0].data.data[0]) || null
        var signedData = (results[1].data && results[1].data.data) || []
        var lostData = (results[2].data && results[2].data.data) || []
        this.signedTotal = signedData.length
        this.lostTotal = lostData.length
        this.signedRows = this.processList(signedData, 'customer_name', 'sign_amount', 'contract_name')
        this.lostRows = this.processList(lostData, 'customer_name', 'opp_amount', 'lost_reason_l2')
        this.signedSum = signedData.reduce(function (s, item) {
          return s + Number(item.sign_amount || 0)
        }, 0)
        this.lostSum = lostData.reduce(function (s, item) {
          return s + Number(item.opp_amount || 0)
        }, 0)
      } catch (e) {
        this.chainSummary = null
        this.signedRows = []
        this.lostRows = []
        this.signedTotal = 0
        this.lostTotal = 0
        this.signedSum = 0
        this.lostSum = 0
      } finally {
        this.loading = false
      }
    },
    processList(data, nameField, amountField, reasonField) {
      if (!data || !data.length) return []
      var sorted = data.slice().sort(function (a, b) {
        return Number(b[amountField] || 0) - Number(a[amountField] || 0)
      })
      var top8 = sorted.slice(0, 8).map(function (item) {
        return [
          item[nameField] || '—',
          Number(item[amountField] || 0),
          item[reasonField] || '—'
        ]
      })
      if (sorted.length > 8) {
        var otherSum = sorted.slice(8).reduce(function (s, item) {
          return s + Number(item[amountField] || 0)
        }, 0)
        top8.push(['其他客户组合', otherSum, '—'])
      }
      return top8
    }
  }
}
</script>

<style lang="scss">
.rpt-chain-operation {
  height: 100%;
  min-height: 0;
  padding: 10px;
  background: #eef3f9;
  overflow-y: auto;
  font-family: "PingFang SC", "HarmonyOS Sans SC", "Microsoft YaHei", -apple-system,
    BlinkMacSystemFont, sans-serif;
  color: #0f172a;
  scrollbar-width: thin;
  scrollbar-color: #fff transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #fff;
    border-radius: 2px;
  }

  .report-shell {
    display: flex;
    height: 100%;
    max-width: 1600px;
    margin: 0 auto;
    flex-direction: column;
  }

  .report-header {
    position: relative;
    overflow: hidden;
    padding: 13px 16px;
    border: 1px solid rgba(148, 163, 184, 0.28);
    border-radius: 15px;
    background: linear-gradient(135deg, #ffffff, #f8fafc);
    box-shadow: 0 16px 38px rgba(15, 23, 42, 0.08);
    flex-shrink: 0;
    &::after {
      content: "";
      position: absolute;
      right: -80px;
      top: -100px;
      width: 260px;
      height: 260px;
      border-radius: 50%;
      background: radial-gradient(
        circle,
        rgba(74, 95, 243, 0.2),
        rgba(74, 95, 243, 0) 68%
      );
      pointer-events: none;
    }
  }
  .header-row {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
  }
  h1 {
    margin: 0 0 4px;
    font-size: 22px;
    line-height: 1.25;
    letter-spacing: -0.02em;
    font-weight: 800;
  }
  .subtitle {
    margin: 0;
    color: #64748b;
    font-size: 12px;
    line-height: 1.5;
    max-width: 900px;
  }
  .header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .report-badge {
    height: 32px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 0 11px;
    border-radius: 9px;
    border: 1px solid rgba(148, 163, 184, 0.28);
    background: #fff;
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
  }
  .analysis-button {
    height: 32px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 0 11px;
    border-radius: 9px;
    border: none;
    background: linear-gradient(135deg, #4a5ff3, #2d7ff9);
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 7px 16px rgba(74, 95, 243, 0.2);
    &:hover {
      filter: brightness(1.05);
    }
  }

  .tab-strip {
    display: grid;
    grid-template-columns: repeat(8, minmax(0, 1fr));
    gap: 5px;
    margin: 7px 0;
    padding: 0;
    flex-shrink: 0;
  }
  .chain-tab {
    min-width: 0;
    padding: 6px 8px;
    border: 1px solid rgba(148, 163, 184, 0.28);
    border-radius: 9px;
    background: #fff;
    color: #64748b;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.2s, background 0.2s, color 0.2s, transform 0.2s;
    display: block;
    &:hover {
      transform: translateY(-1px);
      border-color: rgba(74, 95, 243, 0.4);
    }
    &.is-active {
      border-color: rgba(74, 95, 243, 0.48);
      background: rgba(74, 95, 243, 0.08);
      color: #4a5ff3;
      box-shadow: 0 8px 18px rgba(74, 95, 243, 0.1);
    }
    &.is-disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: #f1f5f9;
      border-color: rgba(148, 163, 184, 0.18);
      color: #94a3b8;
    }
    &.is-disabled:hover {
      transform: none;
      border-color: rgba(148, 163, 184, 0.18);
    }
  }
  .chain-tab-name {
    display: block;
    overflow: hidden;
    font-size: 11px;
    font-weight: 850;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .chain-tab-industry {
    display: block;
    overflow: hidden;
    margin-top: 2px;
    font-size: 9px;
    color: #94a3b8;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .content-card {
    display: flex;
    min-height: 0;
    flex: 1;
    overflow: hidden;
    border: 1px solid rgba(148, 163, 184, 0.28);
    border-radius: 15px;
    background: #fff;
    box-shadow: 0 16px 38px rgba(15, 23, 42, 0.08);
    flex-direction: column;
  }

  #chain-report {
    display: flex;
    min-height: 0;
    flex: 1;
    flex-direction: column;
  }

  .chain-summary {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 12px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.28);
    background: linear-gradient(135deg, rgba(74, 95, 243, 0.06), transparent 68%);
    flex-shrink: 0;
  }
  .chain-identity {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .chain-icon {
    width: 32px;
    height: 32px;
    display: grid;
    place-items: center;
    border-radius: 9px;
    background: linear-gradient(135deg, #4a5ff3, #2d7ff9);
    color: #fff;
    box-shadow: 0 8px 18px rgba(74, 95, 243, 0.2);
    font-size: 14px;
    flex-shrink: 0;
  }
  .chain-name {
    font-size: 15px;
    font-weight: 850;
  }
  .chain-meta {
    margin-top: 2px;
    color: #64748b;
    font-size: 10px;
  }
  .chain-summary-kpis {
    display: flex;
    gap: 13px;
    text-align: right;
    flex-shrink: 0;
  }
  .chain-summary-kpi {
    span {
      display: block;
      font-size: 10px;
      color: #64748b;
    }
    strong {
      display: block;
      margin-top: 2px;
      font-size: 14px;
      font-weight: 800;
    }
  }

  .business-panels {
    display: grid;
    min-height: 0;
    flex: 1;
    // grid-template-columns: 1fr;
    grid-template-rows: repeat(2, minmax(1, 1fr));
    gap: 6px;
    padding: 7px;
  }
  .business-panel {
    display: flex;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    border: 1px solid rgba(148, 163, 184, 0.28);
    border-radius: 12px;
    background: #f8fafc;
    flex-direction: column;
  }
  .business-panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    padding: 6px 9px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.28);
    flex-shrink: 0;
  }
  .business-panel-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 850;
    color: #4a5ff3;
    flex-shrink: 0;
  }
  .business-panel-conclusion {
    min-width: 0;
    color: #64748b;
    font-size: 10px;
    line-height: 1.35;
    text-align: right;
  }

  .mini-table-scroll {
    min-height: 0;
    flex: 1;
    overflow: hidden;
  }
  .mini-table {
    min-width: 0;
    height: 100%;
    font-size: 10px;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
    th,
    td {
      padding: 3px 6px;
      border-right: 1px solid rgba(148, 163, 184, 0.28);
      border-bottom: 1px solid rgba(148, 163, 184, 0.28);
      white-space: normal;
      word-break: break-word;
      vertical-align: middle;
    }
    thead tr:first-child th {
      position: static;
      background: #0d5fac;
      color: #fff;
      font-size: 11px;
      font-weight: 800;
      text-align: center;
    }
    tbody td {
      text-align: center;
    }
    tbody td:first-child {
      font-weight: 750;
      text-align: left;
    }
    .total-row td {
      font-weight: 850;
      background: rgba(74, 95, 243, 0.08);
    }
    .numeric {
      text-align: right;
      font-weight: 750;
    }
    .text-left {
      text-align: left;
    }
    th:last-child,
    td:last-child {
      border-right: 0;
    }
  }

  .tone-primary {
    color: #4a5ff3;
  }
  .tone-positive {
    color: #0aa66a;
  }
  .tone-negative {
    color: #e54b3d;
  }

  .report-foot {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 12px;
    border-top: 1px solid rgba(148, 163, 184, 0.28);
    font-size: 10px;
    color: #64748b;
    line-height: 1.45;
    flex-shrink: 0;
  }
}
</style>
